import { render, staticRenderFns } from "./privacyrule.vue?vue&type=template&id=a6f0f16c&"
import script from "./privacyrule.vue?vue&type=script&lang=js&"
export * from "./privacyrule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports